import React from 'react';
import { Box } from '@mui/material';
import { surface, radius } from '../../theme/tokens';

/**
 * Monospaced, scrollable block for JSON payloads, prompts and raw model
 * output. Sits on the sunken surface so it reads as inert data rather than
 * as interactive content.
 */
const CodeBlock = ({ children, fontSize = '0.8125rem', maxHeight = 320 }) => (
  <Box
    component="pre"
    sx={{
      m: 0,
      p: 2,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      fontSize,
      lineHeight: 1.6,
      color: 'text.secondary',
      bgcolor: surface.sunken,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: `${radius.md}px`,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      overflowX: 'auto',
      maxHeight,
      overflowY: 'auto',
    }}
  >
    {children}
  </Box>
);

export default CodeBlock;
